// Modules
import styled from "styled-components"
import { useNavigate } from "react-router-dom"

// Constants
import colors from "~constants/colors"

// Components
import ArrowLeftIcon from "~images/icons/arrow-left.svg?react"

const BackLinkContainer = styled.div`
  align-items: center;
  color: ${colors.blue1};
  cursor: pointer;
  display: inline-flex;

  > svg {
    margin-right: 5px;
  }
`

interface BackLinkProps {
  text: string
  path?: string
  goBack?: boolean
}

const BackLink = ({ text, path, goBack }: BackLinkProps) => {
  const navigate = useNavigate()

  const onClickHandler = () => {
    if (goBack) navigate(-1)
    else navigate(path!)
  }

  return (
    <BackLinkContainer onClick={onClickHandler}>
      <ArrowLeftIcon />
      {text}
    </BackLinkContainer>
  )
}

export default BackLink
